import { CSVProfile } from '../../types'
import { TableDataChartComponent } from '../charts/table-data-chart-component'
import { TRANSFORM_EXCLUDE_KEY } from '../commons/constants'

export class AFTopEditorialSources extends TableDataChartComponent {
 static config = {
  selector: 'afTopEditorialSources',
  controller: AFTopEditorialSources,
  bindings: TableDataChartComponent.config.bindings,
  template: TableDataChartComponent.config.template,
 }

  buildTableDataOptions() {
    return ['Publications', 'explore__visualizations--key-metrics-mentions']
  }

  buildTableDataChartData(data) {
    // calculate indexes for pagination
    let startIndex = this.pagination.currentPage * this.pagination.pageSize
    let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize
    return data.slice(startIndex, endIndex).map(x => ({
      ...x,
      profileUrl: x.profileUrl.includes('http') ? x.profileUrl: '//'+x.profileUrl,
    }))
  }

  buildCSVExportProfile(): void {
    this.csvExportProfiles = []
    
    let editorialExport: CSVProfile = {
      data: Object.assign({}, this.vizData.data),
      csvOptions: { headers: ['Publications', 'Mentions', 'Publication URL'], showTitle: true },
      transformationProfiles: [{
        key: 'imageUrl', 
        type: TRANSFORM_EXCLUDE_KEY
      }],
    }

    this.csvExportProfiles.push(editorialExport)
  }
}
